import { fromJS } from 'immutable';
import _ from 'lodash';

import { EXECUTE_TEAM_WIDGET_SUCCESS } from 'containers/Team/constants';

import {
  WIDGET_FILTERS_PATH,
  defaultDateRange,
  START_ASSESSMENT,
} from 'containers/WidgetConfiguration/constants';
import {
  FETCH_WIDGET,
  FETCH_WIDGET_SUCCESS,
  UPDATE_WIDGET_SUCCESS,
  FETCH_WIDGET_FAILURE,
  REMOVE_WIDGET,
  RESET_WIDGETS,
} from './constants';

const buildWidgetDefinition = (widget) => {
  if (widget.definition.type !== START_ASSESSMENT) {
    const filters = _.get(widget, WIDGET_FILTERS_PATH);
    const dateRangeFilter = filters.find((f) => f.type === 'primary');

    widget.definition.filter.filters = filters.filter(
      (f) => f.type === 'default'
    );
    widget.definition.filter.dateRange = dateRangeFilter || defaultDateRange;
  }

  return fromJS(widget);
};

/**
 * {
 *   'widgetID': {  // Immutable.Map
 *      widget: { id, type, name, data, columns, groupBy, error },  // JS obj
 *      error: null | {}, // JS obj
 *      loading: bool,
 *   }
 * }
 */
const initialState = fromJS({});

function widgetsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_WIDGET:
      return state
        .setIn([action.widgetID, 'loading'], true)
        .setIn([action.widgetID, 'error'], null);
    case UPDATE_WIDGET_SUCCESS:
      return state.setIn(
        [action.widgetID, 'definition'],
        fromJS(action.widget)
      );
    case FETCH_WIDGET_SUCCESS:
      return state
        .setIn([action.widgetID, 'loading'], false)
        .setIn(
          [action.widgetID, 'definition'],
          buildWidgetDefinition(action.definition)
        ) // for compatibility, can refactor
        .setIn([action.widgetID, 'widget'], action.executedWidget);
    case FETCH_WIDGET_FAILURE:
      return state
        .setIn([action.widgetID, 'loading'], false)
        .setIn([action.widgetID, 'definition'], null)
        .setIn([action.widgetID, 'error'], action.error);

    case EXECUTE_TEAM_WIDGET_SUCCESS:
      return state
        .setIn([action.executedWidget.id, 'widget'], action.executedWidget)
        .setIn(
          [action.executedWidget.id, 'definition'],
          fromJS(action.definition)
        );
    case REMOVE_WIDGET:
      return state.delete(action.widgetID, action.error);
    case RESET_WIDGETS:
      return initialState;
    default:
      return state;
  }
}

export default widgetsReducer;
